<template>
  <SelectField :rules="[valid]" :items="cond_items" v-model="model" v-bind="$attrs" :original_value="original_value"/>
</template>

<script>
import SelectField from '../../common/SelectField.vue'

export default {
  props: {
    value: Object,
    config: Object,
    items: Array,
    field_name: String,
    required: Boolean,
    no_value_specified: Boolean
  },
  data: ()=>({
  }),
  methods:{
    valid(value) {
      if (!this.required) {
        return true
      }

      if (!value) {
        console.log('empty')
        return this.$t('Это обязательное поле')
      }

      if (!this.items) {
        return true
      }

      if (this.items.length == 0) {
        return true
      }

      let r = (this.items|| []).filter((el) => +el.value === +this.model).length >= 1 ? true : this.$t('Это обязательное поле')
      if (r !== true) {
        console.log('whynot', this.model)
      }

      return r
    }
  },
  computed:{
    original_value(){
      return this.config[this.field_name]
    },
    model: {
      get() {
        return this.value ? this.value[this.field_name] : this.original_value
      },
      set(val) {
        let tmp = {...this.value}
        tmp[this.field_name] = val
        this.$emit('input', tmp)
      }
    },
    cond_items(){
      if(this.items)
        return this.no_value_specified ? [{text: this.$t('Не задано'), value: 0}, ...this.items] : this.items
      else{
        return []
      }
    }
  },
  components: {
    SelectField
  }
}
</script>